import { API_URL, apiRequest } from './api';
import { Workflow } from '../components/model';

const API_WORKFLOW_URL = `${API_URL}/workflow`;

export const fetchAllWorkflows = async () => {
  return apiRequest('GET', API_WORKFLOW_URL);
};

export const fetchWorkflowByUuid = async (uuid: string) => {
  return apiRequest('GET', `${API_WORKFLOW_URL}/${uuid}`);
};

export const saveOrUpdateWorkflow = async (
  workflow: Workflow
): Promise<Workflow> => {
  return apiRequest('POST', API_WORKFLOW_URL, workflow) as Promise<Workflow>;
};

export const deleteWorkflow = async (uuid: string) => {
  return apiRequest('DELETE', `${API_WORKFLOW_URL}/${uuid}`);
};
